import { state } from '../map_state/state'
import { importExportTool } from './import_export_tool'
import { callMethodOnKeydown, isTyping } from '../helpers'
import { pathcalculatorTool } from './path_calculator_tool'
import { zoomTool } from './zoom_tool'
import { addSensorTool } from './add_sensor_tool'
import { settingsTool } from './settings_tool'

class ResetTool {
  constructor () {
    this.element = document.getElementById('mct-reset')
    this.toggleVisibility()
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)
    this.reset = this.reset.bind(this)
    this.element.addEventListener('click', this.reset)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.reset)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'r' && !this.element.classList.contains('hidden')) callMethodOnKeydown(e.target, this.reset)
  }

  reset () {
    addSensorTool.tab.innerHTML = ''
    state.reset()
    importExportTool.change()
    pathcalculatorTool.resetDimensions()
    zoomTool.setZoom(state.zoomValue)
    settingsTool.menu.classList.add('hidden')
    document.querySelectorAll('.mct-icons').forEach(icon => icon.classList.remove('selected'))
  }

  toggleVisibility () {
    this.element.classList.toggle('hidden', !state.mapImage)
  }
}

export let resetTool = null

export function initResetTool () {
  resetTool = new ResetTool()
  return resetTool
}
